"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_USER_INFO = void 0;
exports.EMPTY_USER_INFO = {
    roles: [],
    permissions: [],
    userId: '',
    currentRole: '',
    currentRoleType: '',
    companyId: null,
    isAuthenticated: false,
    username: '',
    currentRoleDisplayName: '',
    companyBranchId: null,
};
//# sourceMappingURL=user.js.map